module.exports = __webpack_public_path__ + "static/media/es-api.9be1dea.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/es-api.mp4
// module id = 7XzU
// module chunks = 1